import script from "./stock_logs.vue?vue&type=script&setup=true&lang=js"
export * from "./stock_logs.vue?vue&type=script&setup=true&lang=js"

import "./stock_logs.vue?vue&type=style&index=0&id=4f3db322&lang=css"

const __exports__ = script;

export default __exports__